import { render } from "./OrderBookDetail.vue?vue&type=template&id=5a463edd&scoped=true"
import script from "./OrderBookDetail.vue?vue&type=script&lang=js"
export * from "./OrderBookDetail.vue?vue&type=script&lang=js"

import "./OrderBookDetail.vue?vue&type=style&index=0&id=5a463edd&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a463edd"]])

export default __exports__